function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from 'react';
import clsx from 'clsx';
import { string } from 'prop-types';
import Menu, { menuClasses } from '@mui/material/Menu';
import { styled } from '@mui/material/styles';
const StyledSovosMenu = styled(Menu)(_ref => {
  let {
    theme: {
      spacing
    }
  } = _ref;
  return {
    ["& .".concat(menuClasses.list)]: {
      paddingBottom: spacing(),
      paddingTop: spacing()
    }
  };
});
const SovosMenu = _ref2 => {
  let {
    className,
    ...rest
  } = _ref2;
  return /*#__PURE__*/React.createElement(StyledSovosMenu, _extends({
    className: clsx('sovosMenu', className)
  }, rest));
};
SovosMenu.propTypes = {
  /**
   * Extend the class name applied to the root element
   */
  className: string
};
SovosMenu.baseComponent = {
  name: 'Menu',
  link: 'menu/'
};
export default SovosMenu;